import { IconName, PalmettoIcon } from '@palmetto/dsm-components';
import { Button } from '../Button/Button';
import useComponentTracking from '../../hooks/useComponentTracking';
import { Cta } from '../../types/cta';
import CyclingIcons from '../CyclingIcons/CyclingIcons';

export interface GenericStepLayoutProps {
  icon: IconName | IconName[];
  title: string;
  description: React.ReactNode;
  primaryCTA?: Omit<Cta, 'trackingId'>;
  secondaryCTA?: Omit<Cta, 'trackingId'>;
  trackingId: string;
}

export function GenericStepLayout({
  title,
  description,
  icon,
  primaryCTA,
  secondaryCTA,
  trackingId,
}: GenericStepLayoutProps) {
  useComponentTracking(trackingId);

  return (
    <div className="flex flex-col gap-24 max-w-3xl mx-auto px-24 py-64 md:p-64 h-full md:h-auto justify-between ">
      <div className="flex flex-col gap-24 text-text-primary">
        <h1 className="heading-700 mb-12 break-words overflow-wrap-anywhere">{title}</h1>
        <div className="body-400 mt-4">{description}</div>
        <div className="flex items-center justify-center">
          {Array.isArray(icon) ? (
            <CyclingIcons iconNames={icon} speed={300} size="3xl" />
          ) : (
            <PalmettoIcon name={icon} size="3xl" />
          )}
        </div>
      </div>
      <div className="flex flex-col gap-12">
        {primaryCTA && (
          <Button {...primaryCTA} trackingId={`${trackingId}-primary-cta`}>
            {primaryCTA.label || ''}
          </Button>
        )}
        {secondaryCTA && (
          <Button {...secondaryCTA} emphasis="secondary" trackingId={`${trackingId}-secondary-cta`}>
            {secondaryCTA.label || ''}
          </Button>
        )}
      </div>
    </div>
  );
}

export default GenericStepLayout;
